import { createContext, useContext, useState, useEffect } from "react";
import { apiFetchAdmin } from '../../hooks/apiFetch';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useLangUrl } from '../../utilities/useLangUrl';
// import Cookies from 'js-cookie';

const AdminAllUsersContext = createContext();

export function AdminAllUsersProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [userDataTotalCount, setUserDataTotalCount] = useState("");
    const [allUsersData, setAllUsersData] = useState(null);
    const langUrl = useLangUrl();

    const navigate = useNavigate();

    useEffect(() => {
        if (!Cookies.get('adminToken')) {
            navigate("/admin/adminLogin")
        }

        async function fetchAllUsers() {
            setLoading(true);
            try {
                const allUsers = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/users?limit=${userDataTotalCount ? userDataTotalCount : 1}`);

                setAllUsersData(allUsers);
                setUserDataTotalCount(allUsers.data?.paginationInfo.totalCount)
            } catch (err) {
                setAllUsersData(null);
                setUserDataTotalCount(null)

            } finally {
                setLoading(false);
            }
        }
        fetchAllUsers();
    }, [navigate, userDataTotalCount, langUrl]);


    return (
        <AdminAllUsersContext.Provider
            value={{
                loading, setLoading, userDataTotalCount, setUserDataTotalCount,
                allUsersData, setAllUsersData
            }}>
            {children}
        </AdminAllUsersContext.Provider>
    );
}

export function useAdminAllUsers() {
    return useContext(AdminAllUsersContext);
}